export const tooltipContent = {
    calculationMode: {
      title: 'Berechnungsmodus',
      description: 'Wählen Sie, ob Sie die PayPal-Gebühren berechnen oder die gewünschte Endsumme eingeben möchten.',
      fees: 'Berechnet die anfallenden PayPal-Gebühren basierend auf dem Eingabebetrag',
      final: 'Berechnet den Eingabebetrag für die gewünschte Endsumme inkl. Gebühren'
    },
    amount: {
      title: 'Betrag',
      description: 'Geben Sie den Betrag ein, für den Sie die PayPal-Gebühren berechnen möchten'
    },
    paymentType: {
      title: 'Art der Zahlung',
      description: 'Wählen Sie die Art der PayPal-Zahlung aus. Die Gebühren variieren je nach Zahlungsart'
    }
  };